import React, { useEffect, useState } from 'react';
import './style.scss';
import LargeLogo from '../../../Assets/icons/LargeLogo';
import HomeHeaderBg from '../../../Assets/icons/HomeHeaderBg';

const HomeHeader = () => {
    const [isSmallHeight, setIsSmallHeight] = useState(false);

    useEffect(() => {
        const checkHeight = () => {
            setIsSmallHeight(window.innerHeight < 700);
        };

        checkHeight();
        window.addEventListener('resize', checkHeight);

        return () => window.removeEventListener('resize', checkHeight);
    }, []);

    return (
        <>
            <div className="HomeHeader--bg">
                <HomeHeaderBg />
            </div>
            <div className="logo responsive--logo">
                {isSmallHeight ? <LargeLogo width={125} height={130} /> : <LargeLogo />}
            </div>
        </>
    );
};

export default HomeHeader;
